// features/shop/shop-sidebar/components/ShopSidebar.tsx
'use client';
import React, { useCallback } from 'react';
import CategoryFilter from './CategoryFilter';
import PriceRangeFilter from './PriceRangeFilter';
import SkinTypeFilter from './SkinTypeFilter';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { MdOutlineClose } from 'react-icons/md';
type CategoryClickPayload = {
  category: string | null;
  good_for: string | null;
  type: string | null;
  brand: string | null;
};
const ShopSidebar = ({
  onClose,
  isMobileOpen,
}: {
  onClose: () => void;
  isMobileOpen: boolean;
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const { data: sidebarData } = useFetcherCSR(`/api/v2/sidebar-data?new=true`);

  const createQueryString = useCallback(
    (updates: Record<string, string | null>) => {
      const params = new URLSearchParams(searchParams.toString());

      // Always reset page to 1 on filter changes
      params.set('page', '1');

      Object.entries(updates).forEach(([key, value]) => {
        value ? params.set(key, value) : params.delete(key);
      });

      return params.toString();
    },
    [searchParams]
  );

  const handleCategoryChange = (payload: CategoryClickPayload) => {
    const updates: Record<string, string | null> = {
      category: payload.category,
      type: payload.type,
      good_for: payload.good_for,
      brand: payload.brand,
      min_price: null,
      max_price: null,
      skin_type: null,
    };

    router.push(`${pathname}?${createQueryString(updates)}`, { scroll: false });
  };
  const handleSkinTypeChange = (types: string[]) => {
    const skin_type = types.length > 0 ? types.join(',') : null;
    router.push(`${pathname}?${createQueryString({ skin_type })}`, {
      scroll: false,
    });
  };

  const handlePriceChange = (min: number | null, max: number | null) => {
    const updates = {
      min_price: min?.toString() || null,
      max_price: max?.toString() || null,
    };

    router.push(`${pathname}?${createQueryString(updates)}`, { scroll: false });
  };

  return (
    <div className="product__sidebar">
      <button
        className={`sidebar-close d-lg-none ${isMobileOpen ? 'd-block' : 'd-none'}`}
        onClick={onClose}
      >
        <MdOutlineClose size={28} />
      </button>

      <CategoryFilter
        onCategoryClick={handleCategoryChange}
        categories={sidebarData?.sidebarList || []}
        selectedCategory={
          searchParams.get('category') ||
          searchParams.get('type') ||
          searchParams.get('good_for') ||
          searchParams.get('brand')
        }
      />

      <PriceRangeFilter
        initialMin={
          searchParams.get('min_price')
            ? Number(searchParams.get('min_price'))
            : undefined
        }
        initialMax={
          searchParams.get('max_price')
            ? Number(searchParams.get('max_price'))
            : undefined
        }
        onPriceChange={handlePriceChange}
      />

      {/* <SkinTypeFilter
        selectedTypes={searchParams.get('skin_type')?.split(',') || []}
        onSelect={handleSkinTypeChange}
      /> */}
    </div>
  );
};

export default ShopSidebar;
